import { Col, Empty, Row } from 'antd';
import { toQueryString } from 'libs/utils';
import { useRouter } from 'next/router';
import { CategoryPageData } from 'pages/shop/category/[id]';
import { useState } from 'react';
import { Icon } from 'react-vant';
import SearchInput from './SearchInput';
import ShopInfoHead, { ShopCategoryItem } from './ShopInfoHead';

export default function ShopCategoryContentH5(props: CategoryPageData) {
  const router = useRouter();
  const shopSysNo = router.query.id;
  const [categories, setCategories] = useState<Array<ShopCategoryItem>>(
    props?.shopInfo?.mallCategoryTreeDTO?.categories || [],
  );

  function handleSearch(keyword) {
    pushListPage({
      key: keyword,
    });
  }

  function pushListPage(condition = {}) {
    router.push(`/shop/list/${shopSysNo}${toQueryString(condition)}`);
  }

  function handleClickCategory(item: ShopCategoryItem) {
    pushListPage({
      categoryName: item.title,
      catId: item.id,
    });
  }

  function handleClickMore(item: ShopCategoryItem) {
    item.showMore = !item.showMore;
    setCategories([...categories]);
  }

  return (
    <div>
      <SearchInput isSearchSku placeholder="搜索店铺内商品" onSearch={handleSearch} />
      <ShopInfoHead {...props.shopInfo} />
      <div className="category-content-wrap">
        {categories?.length ? (
          categories.map((item, index) => (
            <div key={index} className="category-item">
              <div
                className="category-item-head"
                onClick={() => {
                  handleClickCategory(item);
                }}
              >
                <span className="category-item-head-left">{item.title}</span>
                <Icon name="arrow" color="#C6C6C6" />
              </div>
              <div>
                <Row gutter={5}>
                  {(item.showMore ? item?.children : item?.children?.slice(0, 6))?.map(
                    (subItem, subIndex) => (
                      <Col key={subIndex} span={12}>
                        <div
                          className="category-sub-item"
                          onClick={() => {
                            handleClickCategory(subItem);
                          }}
                        >
                          {subItem.title}
                        </div>
                      </Col>
                    ),
                  )}
                </Row>
              </div>
              {item?.children?.length > 6 && (
                <div
                  className="more-btn"
                  onClick={() => {
                    handleClickMore(item);
                  }}
                >
                  {item.showMore ? (
                    <>
                      <span className="more-btn-txt">收起</span>
                      <Icon name="arrow-up" color="#AAAAAA " />
                    </>
                  ) : (
                    <>
                      <span className="more-btn-txt">更多</span>
                      <Icon name="arrow-down" color="#AAAAAA " />
                    </>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <Empty description="暂无数据" />
        )}
      </div>
      <style jsx>{`
        .category-content-wrap {
          padding: 10px;
          line-height: 1;
        }
        .category-item {
          background-color: #fff;
          padding: 0 10px 10px 10px;
          border-radius: 3px;
          margin-bottom: 10px;
        }
        .category-item-head {
          padding: 16px 0 11px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .category-item-head-left {
          font-size: 14px;
          color: #333333;
          font-weight: bold;
        }
        .category-sub-item {
          background: #f2f2f2;
          border-radius: 1px;
          padding: 12px 0 12px 12px;
          margin-top: 5px;
          font-size: 12px;
          color: #666666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
        .more-btn {
          padding: 10px 0 5px 0;
          text-align: center;
        }
        .more-btn-txt {
          margin-right: 5px;
          color: #666666;
          font-size: 12px;
        }
      `}</style>
    </div>
  );
}
